<div class="container">
  <div>
    <div class="title">
      <span>{{'Infomaniak, toutes les solutions dont vous avez besoin pour evoluer en ligne' | transloco}}</span>
    </div>
    <div class="check-block">
      <img src="/assets/images/ui/check.svg" />
      <div>{{'Securite et vie privee garantie.' | transloco}}</div>
    </div>
    <div class="check-block">
      <img src="/assets/images/ui/check.svg" />
      <div>{{'Infrastructure et logiciel developpe et heberge en Suisse.' | transloco}}</div>
    </div>
    <div class="check-block">
      <img src="/assets/images/ui/check.svg" />
      <div>{{'Support 7/7 a Geneve et Winterthour' | transloco}}</div>
    </div>
  </div>
  <div>
    <div class="title2">{{'Pour les entreprises, les organisations publiques et les particuliers' | transloco}}</div>
    <div class="app">
      <div class="app-block">
        <img src="/assets/images/ksuite/ksuite-logo-only.svg" alt="kSuite" />
        <div class="app-block-right">
          <span class="app-block-right-title">kSuite</span>
        </div>
      </div>
      <div class="app-block">
        <img src="/assets/images/ui/products/swiss-backup.svg" alt="Swiss Backup" />
        <div class="app-block-right">
          <span class="app-block-right-title">Swiss Backup</span>
        </div>
      </div>
      <div class="app-block">
        <img src="/assets/images/ksuite/applications/hosting.svg" />
        <div class="app-block-right">
          <span class="app-block-right-title">{{'Hebergement Web' | transloco}}</span>
        </div>
      </div>
      <div class="app-block">
        <img src="/assets/images/ksuite/applications/mail.svg" alt="Mail" />
        <div class="app-block-right">
          <span class="app-block-right-title">Mail</span>
        </div>
      </div>
      <div class="app-block">
        <img src="/assets/images/ksuite/applications/domain.svg" alt="Domain" />
        <div class="app-block-right">
          <span class="app-block-right-title">{{'Nom de domaine' | transloco}}</span>
        </div>
      </div>
      <div class="app-block">
        <img src="/assets/images/ui/products/public-cloud.svg" alt="Public Cloud" />
        <div class="app-block-right">
          <span class="app-block-right-title">{{'Public Cloud' | transloco}}</span>
        </div>
      </div>
      <div class="app-block">
        <img src="/assets/images/ksuite/applications/drive.svg" alt="kDrive" />
        <div class="app-block-right">
          <span class="app-block-right-title">kDrive</span>
        </div>
      </div>
      <div class="app-block">
        <img src="/assets/images/ui/products/tickets.svg" />
        <div class="app-block-right">
          <span class="app-block-right-title">{{'Billetterie' | transloco}}</span>
        </div>
      </div>
      <div class="app-block">
        <img src="/assets/images/ui/products/cloud.svg" />
        <div class="app-block-right">
          <span class="app-block-right-title">{{'Serveur Cloud' | transloco}}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    {{'Et de nombreuses autres applications...' | transloco}}
  </div>
</div>
